import { render, staticRenderFns } from "./orderSettlement.vue?vue&type=template&id=1d5e2467&scoped=true&"
import script from "./orderSettlement.vue?vue&type=script&lang=js&"
export * from "./orderSettlement.vue?vue&type=script&lang=js&"
import style0 from "./orderSettlement.vue?vue&type=style&index=0&id=1d5e2467&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5e2467",
  null
  
)

export default component.exports